import styles from './styles.module.css';

import { useNavigate, useLocation } from 'react-router-dom';

import { motion } from 'framer-motion';
import { useContext, useEffect, useState } from 'react';
import Loading from '../../components/Loading';
import {
  ArtStatusService,
  BusinessClient,
  BusinessService,
  BusinessUser,
  MetricsCountService,
  PlanLimitsService,
  ProductService,
  SubscriptionService,
  TargetAudienceService,
  UserAccountsService,
  UserPlanCount,
  UserSatisfactionService,
} from '../../services';
import { notifyWarningCustom2 } from '../../utils/notify';
import { useTranslation } from 'react-i18next';
import ModalValidDowngrade from '../../components/ModalValidDowngrade';
import { SatisfactionPopUp } from '../../components/SatisfactionPopUp';
import { useClient } from '../../hooks/useClient';
import { getBusinessByClientId } from '../../services/business';
import { UseSevenDaysModal } from './hooks/useSevenDaysModal';
import { RoundedProgressBarCard } from '../../components/RoundedProgressBarCard';
import { getArtGenerationAvailability } from '../../utils/artConsumption';

// import { ReturnFirstMissionModal } from '../../components/ReturnFirstMissionModal';
// import { FirstMissionContext } from '../../contexts/userMissions/CheckUserMissionContext';
// import { UseMissionSteps } from './hooks/useMissionSteps';
// import { UseMissionModal } from './hooks/useMissionModal';
import { UseCheckArtPending } from '../../hooks/useCheckArtPending';
import { ArtPendingPopUp, ArtStatusErrorPopUp } from '../../components';
import { ArtPedingContext } from '../../contexts/ArtPendingContext/ArtPendingContext';
import { usePaywall } from '../../contexts/PaywallContext/usePaywall';

function NewPostPage() {

  const navigation = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [blockDowngrade, setBlockDowngrade] = useState(false);
  const [parameterPercent, setParameterPercent] = useState(0);
  const [percentString, setPercentString] = useState('0');
  const [widthIcon, setWidthIcon] = useState(92);
  const [widthIconPicture, setWidthIconPicture] = useState(103);
  const [isFirstGenerateArt, setIsFirstGenerateArt] = useState(false);
  const [isArtPendingPopUpOpen, setIsArtPendingPopUpOpen] = useState(null);
  const { clientData } = useClient();
  const { openPaywall } = usePaywall();
  const [firstOppenPostIA, setFirstOppenPostIA] = useState()
  const { handleSevenDaysModal, showSevenDaysModal, checkSevenDaysPassed } = UseSevenDaysModal();


  // const { userMissionStatus, showReturnMissionPopUp, setShowReturnMissionPopUp } = useContext(FirstMissionContext)

  // hook para verificar se há arte pendente e redirecionar para tela de geração de artes
  const { handleVerifyHasArtPending, artStatus, setArtStatus } = UseCheckArtPending()




  //Verifica se o modal foi rejeitado na FirstPublication
  // useEffect(() => {
  //   if(location?.state?.modalRejected){
  //     setShowReturnMissionPopUp(false)
  //   }
  // }, [location?.state?.modalRejected])

  //hook responsavel por renderizar os passos finalizados do componente de percentagem de steps completos
  // const {
  //   stepsMissionCompleted,
  //   isFirstLoggin,
  //   maxSteps,
  //   showPercentageCard,
  //   missionPercentageCardContentToRender,
  //   handleClickPercentageCardNavigateButton,
  //   mission
  // } = UseMissionSteps(userMissionStatus)


  //hook responsavel pela renderização do modal de retorno para a missão e seu conteúdo conforme o status da missão
  // const {
  //   bodyMissionContentModal,
  //   headerMissionContentModal,
  //   renderBannerReturnPublication,
  //   setRenderBannerReturnPublication,
  //   // setShowReturnMissionPopUp,
  //   primaryButtonMissionContentModal,
  //   secondaryButtonMissionContentModal,
  //   handleRediRedirectMissionPopUp
  // } = UseMissionModal(
  //   {
  //     missionStatus:userMissionStatus,
  //     setShowReturnMissionPopUp,
  //     showReturnMissionPopUp
  //   }
  // )

  let userRating = 0

  useEffect(() => {
    loadBasicFunctionData()

  }, []);

  // useEffect(() => {
  //   // const isFirstGenerate = firstOppenPostIA?.data?.firstOppenPostIA
  //   if (artStatus && artStatus?.status !== 'PENDING' && !artStatus.isVisualized) {
  //     navigation('/NewPublicationPageIA', {
  //       state: {
  //         ...location.state,
  //       }
  //     })
  //   }
  // }, [artStatus?.status, artStatus?.isVisualized])

  useEffect(() => {
    if (artStatus && !artStatus.isVisualized) {
      const shouldRenderPopUp = localStorage.getItem('pendingArtPopupShown') === 'true'
      setIsArtPendingPopUpOpen(shouldRenderPopUp)
    }

  }, [artStatus, localStorage.getItem('pendingArtPopupShown')])

  ''
  const loadBasicFunctionData = async () => {
    const response = await UserAccountsService.getFirstOppenPostIA()
    setFirstOppenPostIA(response)
    await handleVerifyHasArtPending()
    await getParameterUserPercent();
    await handleFirstGenerateArt();
    await checkSevenDaysPassed();

    if (!artStatus || artStatus?.isVisualized) {
      await checkBusinessParametrizations()
    }
  }

  const checkBusinessParametrizations = async () => {
    const subscriptionFeatures =
      await SubscriptionService.getSubscriptionFeatures()

    if (subscriptionFeatures?.data?.allowSinglePostGeneration === false) {
      return
    }

    const businessResponse = await BusinessService.getBusinessByLogin()
    const businessExist = businessResponse.data.length === 0 || !businessResponse.data
    if (businessExist) {
      navigation('/NewPublicationPageIA')

    }
  }

  function atualizarVariaveis() {
    if (window.innerWidth < 1370) {
      setWidthIcon(60)
      setWidthIconPicture(80)
    } else {
      setWidthIcon(92)
      setWidthIconPicture(103)
    }
  }

  useEffect(() => {
    // Chama uma vez ao montar
    atualizarVariaveis()

    // Adiciona o event listener
    window.addEventListener('resize', atualizarVariaveis);



    // Remove o event listener ao desmontar
    return () => {
      window.removeEventListener('resize', atualizarVariaveis);
    };
  }, []);

  const handleFirstGenerateArt = async () => {
    const { data } =
      await UserAccountsService.getFirstGenerateArt();
    setIsFirstGenerateArt(data.firstGenerateArt);
  };
  const formatNumber = async (num) => {
    // Arredonda para no máximo 2 casas decimais
    const rounded = Math.round(num * 100) / 100

    // Verifica se o número está entre 0 e 1 (começa com 0.)
    if (rounded > 0 && rounded < 1) {
      return rounded.toString()
    }

    return num.toString()
  }

  const getPlanItemQuantity = (userSubscription, itemType) => {
    const planItems = userSubscription?.data?.[0]?.Plan?.PlanItems

    if (!Array.isArray(planItems)) {
      return null
    }

    const planItem = planItems.find((item) => item.type === itemType)
    return planItem?.quantity ?? null
  }

  // const registerEvent = async (data) => {
  //   await EventMapService.postEventMap(data)
  // }
  const getParameterUserPercent = async () => {
    const percent = await UserAccountsService.getUserPamareterPercent()

    setParameterPercent(await formatNumber(percent?.data?.countcomplete))

    // if (await formatNumber(percent?.data?.countcomplete) != '1') {
    //   const dataEvent = {
    //     event: 'popup_param_reminder_shown',
    //     eventData: {},
    //   }
    //   registerEvent(dataEvent)
    // }

    switch (await formatNumber(percent?.data?.countcomplete)) {
      case '0.2':
        setPercentString('20');
        break;
      case '0.4':
        setPercentString('40');
        break;
      case '0.6':
        setPercentString('60');
        break;
      case '0.8':
        setPercentString('80');
        break;
      case '1':
        setPercentString('100');
        break;
      default:
        break;
    }
    setPercentString
  }

  const handleValidBlockDowngrade = async (userSubscription) => {
    let blockDowngrade = false
    const productCount = await ProductService.getAllproductCount()

    if (userSubscription.data.length <= 0 && productCount.data.count > 30) {
      blockDowngrade = true
      return blockDowngrade
    } else if (userSubscription.data.length > 0) {
      const quantityProduct = getPlanItemQuantity(
        userSubscription,
        'product_quantity'
      )

      if (
        productCount.data.count > quantityProduct &&
        quantityProduct != null
      ) {
        blockDowngrade = true
        return blockDowngrade
      }
    }

    const businessTargetAudienceCount =
      await TargetAudienceService.getAllTargetAudienceCount()

    if (
      userSubscription.data.length <= 0 &&
      businessTargetAudienceCount.data.count > 30
    ) {
      blockDowngrade = true
      return blockDowngrade
    } else if (userSubscription.data.length > 0) {
      const quantityTargetAudience = getPlanItemQuantity(
        userSubscription,
        'target_audience_quantity'
      )

      if (
        businessTargetAudienceCount.data.count > quantityTargetAudience &&
        quantityTargetAudience != null
      ) {
        blockDowngrade = true
        return blockDowngrade
      }
    }

    const businessUserCount = await BusinessUser.getAllBusinessUserCount()
    if (userSubscription.data.length <= 0 && businessUserCount.data.count > 1) {
      blockDowngrade = true
      return blockDowngrade
    } else if (userSubscription.data.length > 0) {
      const quantityItemUser = getPlanItemQuantity(
        userSubscription,
        'user_quantity'
      )

      if (
        businessUserCount.data.count > quantityItemUser &&
        quantityItemUser != null
      ) {
        blockDowngrade = true
        return blockDowngrade
      }
    }

    const businessClientCount = await BusinessClient.getAllBusinessClientCount()

    if (
      userSubscription.data.length <= 0 &&
      businessClientCount.data.count > 1
    ) {
      blockDowngrade = true
      return blockDowngrade
    } else if (userSubscription.data.length > 0) {
      const quantityClient = getPlanItemQuantity(
        userSubscription,
        'client_quantity'
      )

      if (
        businessClientCount.data.count > quantityClient &&
        quantityClient != null
      ) {
        blockDowngrade = true
        return blockDowngrade
      }
    }

    return blockDowngrade
  }

  const handleSendStars = async () => {

    const response = await UserSatisfactionService.postUserSatisfaction({
      userRating: userRating,
      userComment: '',
      origin: 'sevenDays',
    });
    const { responseStatus } = response
    if (responseStatus === 200 || responseStatus === 204) {
      handleSevenDaysModal(false);
    }
  }

  // const StarRating = () => {
  //   const [rating, setRating] = useState(0)

  //   const lottieRefs1 = useRef()
  //   const lottieRefs2 = useRef()
  //   const lottieRefs3 = useRef()
  //   const lottieRefs4 = useRef()
  //   const lottieRefs5 = useRef()

  //   const handleClick = (index) => {
  //     setRating(index + 1)
  //   }

  //   useEffect(() => {
  //     if (rating === 1) {
  //       ratingRef.current = 1

  //       lottieRefs1.current.goToAndPlay(29, true)

  //       lottieRefs2.current.stop()
  //       lottieRefs3.current.stop()
  //       lottieRefs4.current.stop()
  //       lottieRefs5.current.stop()
  //     } else if (rating === 2) {
  //       ratingRef.current = 2

  //       lottieRefs1.current.goToAndPlay(29, true)
  //       lottieRefs2.current.goToAndPlay(29, true)

  //       lottieRefs3.current.stop()
  //       lottieRefs4.current.stop()
  //       lottieRefs5.current.stop()
  //     } else if (rating === 3) {
  //       ratingRef.current = 3

  //       lottieRefs1.current.goToAndPlay(29, true)
  //       lottieRefs2.current.goToAndPlay(29, true)
  //       lottieRefs3.current.goToAndPlay(29, true)

  //       lottieRefs4.current.stop()
  //       lottieRefs5.current.stop()
  //     } else if (rating === 4) {
  //       ratingRef.current = 4

  //       lottieRefs1.current.goToAndPlay(29, true)
  //       lottieRefs2.current.goToAndPlay(29, true)
  //       lottieRefs3.current.goToAndPlay(29, true)
  //       lottieRefs4.current.goToAndPlay(29, true)

  //       lottieRefs5.current.stop()
  //     } else if (rating === 5) {
  //       ratingRef.current = 5

  //       lottieRefs1.current.goToAndPlay(29, true)
  //       lottieRefs2.current.goToAndPlay(29, true)
  //       lottieRefs3.current.goToAndPlay(29, true)
  //       lottieRefs4.current.goToAndPlay(29, true)
  //       lottieRefs5.current.goToAndPlay(29, true)
  //     }
  //   }, [rating])

  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         cursor: 'pointer',
  //         // gap: 8, // Espaçamento entre as estrelas
  //       }}
  //     >
  //       {[0, 1, 2, 3, 4].map((index) => (
  //         <div
  //           style={{
  //             width: 40,
  //             height: 40,
  //             display: 'flex',
  //             justifyContent: 'center',
  //             alignItems: 'center',
  //             overflow: 'hidden',
  //             position: 'relative',
  //           }}
  //           key={index}
  //           onClick={() => handleClick(index)}
  //         >

  //           <div
  //             style={{
  //               position: 'absolute',
  //               top: '50%',
  //               left: '50%',
  //               transform: 'translate(-48%, -46%) scale(1.8)', // Aumenta a animação sem aumentar a área clicável
  //             }}
  //           >
  //             <Lottie
  //               lottieRef={
  //                 index === 0
  //                   ? lottieRefs1
  //                   : index === 1
  //                     ? lottieRefs2
  //                     : index === 2
  //                       ? lottieRefs3
  //                       : index === 3
  //                         ? lottieRefs4
  //                         : lottieRefs5
  //               }
  //               animationData={starAnimated}
  //               style={{ width: 50, height: 50 }}
  //               loop={false}
  //               autoplay={false}
  //             />
  //           </div>
  //         </div>
  //       ))}
  //     </div>
  //   )
  // }



  const handleNavigate = async (route) => {


    setLoading(true)

    if (route === '/ChatSocket') {
      const planLimitResponse =
        await PlanLimitsService.checkCampaignInitiationLimit()
      const hasCampaignLimitAvailable =
        planLimitResponse?.responseStatus === 200 &&
          typeof planLimitResponse?.data === 'boolean'
          ? planLimitResponse.data
          : null

      if (hasCampaignLimitAvailable === false) {
        openPaywall({
          reason: 'campaign_limit_reached',
          returnTo: route,
        })
        setLoading(false)
        return
      }
    }

    const userPlanCount = await UserPlanCount.getUserPlanCountByUser()
    const userSubscription = await SubscriptionService.getSubscriptionByUser()
    const userSubscriptionFeatures =
      await SubscriptionService.getSubscriptionFeatures()
    const userPlanCountData = Array.isArray(userPlanCount?.data)
      ? userPlanCount.data[0]
      : userPlanCount?.data
    const userPlanCountId = userPlanCountData?.uuid ?? userPlanCountData?.id
    const subscriptionData = Array.isArray(userSubscription?.data)
      ? userSubscription.data
      : []
    const mesAtual = new Date(new Date().setDate(1)) // Primeiro dia do mês atual
    mesAtual.setDate(mesAtual.getDate() + 30)
    mesAtual.setHours(0, 0, 0, 0)

    const blockDowngrade = await handleValidBlockDowngrade(userSubscription)

    if (blockDowngrade) {
      setBlockDowngrade(true)
      setLoading(false)
      return
    }

    if (route === '/NewPublicationPageIA') {
      const { hasAvailableArts } = await getArtGenerationAvailability(1)

      if (!hasAvailableArts) {
        openPaywall({
          reason: 'art_generation_limit_reached',
          returnTo: route,
        })
        setLoading(false)
        return
      }
    } else if (!userPlanCountData) {
      await UserPlanCount.postUserPlanCount({
        ownScheduleCount: 0,
        postOnDesignCount: 0,
        imageBankCount: 0,
        aiImageCount: 0,
        aiLegendCount: 0,
        aiMessageCount: 0,
        renewalDate:
          subscriptionData.length > 0
            ? subscriptionData[0].expiration
            : mesAtual,
      })
    } else {
      const renewalDate = new Date(userPlanCountData.renewalDate)
      const dataAtual = new Date()

      const expirationPlan =
        subscriptionData.length > 0
          ? new Date(subscriptionData[0].expiration)
          : new Date(mesAtual)

      const renewalDateStr = new Date(userPlanCountData.renewalDate)
        .toISOString()
        .split('T')[0]
      const expirationPlanStr = expirationPlan.toISOString().split('T')[0]

      if (
        renewalDate.getTime() < dataAtual.getTime() ||
        renewalDateStr !== expirationPlanStr
      ) {
        if (userPlanCountId) {
          await UserPlanCount.putUserPlanCount(userPlanCountId, {
            ownScheduleCount: 0,
            postOnDesignCount: 0,
            imageBankCount: 0,
            aiImageCount: 0,
            aiLegendCount: 0,
            aiMessageCount: 0,
            artGenerationCount: 0,
            renewalDate:
              subscriptionData.length > 0
                ? subscriptionData[0].expiration
                : mesAtual,
          })
        }
      } else {
        if (route === '/ChatSocket') {
          if (userSubscriptionFeatures?.data?.campaignTrialAvailable === false) {
            openPaywall({
              reason: 'campaign_trial_unavailable',
              returnTo: route,
            })
            setLoading(false)
            return
          }

          let limit =
            (userSubscriptionFeatures?.data?.singlePostLimit ?? 0) +
            (userSubscriptionFeatures?.data?.additionalSinglePostQuantity ?? 0)

          if (userSubscription.data.length > 0) {
            const index = userSubscription.data[0].Plan.PlanItems.findIndex(
              (item) => item.type === 'art_generation_count'
            );
            if (index !== -1 && userSubscription.data[0].Plan.PlanItems[index]?.quantity != null) {
              limit =
                userSubscription.data[0].Plan.PlanItems[index].quantity +
                (userSubscriptionFeatures?.data?.additionalSinglePostQuantity ?? 0);
            }
          }

          const balance = limit - (userPlanCount.data.artGenerationCount || 0);

          if (balance < 3) {
            openPaywall({
              reason: 'campaign_art_balance_low',
              returnTo: route,
            })
            setLoading(false)
            return
          }
        } else if (route == '/NewPublicationPageMyPublication') {
          if (userSubscriptionFeatures?.data?.unlimitedScheduling === true) {
            navigation(route)
            setLoading(false)
            return
          }

          if (
            userSubscription.data.length <= 0 &&
            userPlanCount.data.ownScheduleCount >= 10
          ) {
            // notifyWarningCustom(t("plans.user_plan_count_scheduling"));
            notifyWarningCustom2(
              t('plans.user_plan_count_post_design'),
              <div className={styles.container_warning}>
                <p>Aviso!</p>
                <div
                  onClick={() => navigation('/PlanCheckoutUser')}
                  style={{
                    fontSize: 12,
                    fontWeight: 300,
                    fontFamily: 'Poppins',
                    cursor: 'pointer',

                    backgroundColor: '#7A7E00',
                    color: '#f2f486',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    padding: '0px 16px',
                    margin: '0px 0px',
                    borderRadius: 10,
                    height: 30,
                  }}
                >
                  {t('plans.user_plan_count_post_change_plan_button')}
                </div>
              </div>
            )
            setLoading(false)
            return
          } else if (userSubscription.data.length > 0) {
            const quantityAiImage = getPlanItemQuantity(
              userSubscription,
              'scheduling_quantity'
            )

            if (
              userPlanCount.data.ownScheduleCount >= quantityAiImage &&
              quantityAiImage != null
            ) {
              notifyWarningCustom2(
                t('plans.user_plan_count_post_design'),
                <div className={styles.container_warning}>
                  <p>Aviso!</p>
                  <div
                    onClick={() => navigation('/PlanCheckoutUser')}
                    style={{
                      fontSize: 12,
                      fontWeight: 300,
                      fontFamily: 'Poppins',
                      cursor: 'pointer',

                      backgroundColor: '#7A7E00',
                      color: '#f2f486',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      padding: '0px 16px',
                      margin: '0px 0px',
                      borderRadius: 10,

                      height: 30,
                    }}
                  >
                    {t('plans.user_plan_count_post_change_plan_button')}
                  </div>
                </div>
              )
              setLoading(false)
              return
            }
          }
        } else if (route == '/NewPublicationPageIA') {
          const { hasAvailableArts } = await getArtGenerationAvailability(1)

          if (!hasAvailableArts) {
            openPaywall({
              reason: 'art_generation_limit_reached',
              returnTo: route,
            })
            setLoading(false)
            return
          }
        }
      }
    }

    const metricsCount = await MetricsCountService.getMetricsCountTodayByUser()

    if (metricsCount.data) {
      const dataMetrics = {
        ownScheduleCount:
          route == '/NewPublicationPageMyPublication'
            ? metricsCount.data.ownScheduleCount + 1
            : metricsCount.data.ownScheduleCount,
        postOnDesignCount:
          route == '/NewPublicationPage'
            ? metricsCount.data.postOnDesignCount + 1
            : metricsCount.data.postOnDesignCount,
        campaignCount:
          route == '/NewPublicationPageCampaign'
            ? metricsCount.data.campaignCount + 1
            : metricsCount.data.campaignCount,
        calendarCount: metricsCount.data.calendarCount,
      }

      await MetricsCountService.putMetricsCount(
        metricsCount.data.uuid,
        dataMetrics
      )
    } else {
      const dataMetrics = {
        ownScheduleCount: route == '/NewPublicationPageMyPublication' ? 1 : 0,
        postOnDesignCount: route == '/NewPublicationPage' ? 1 : 0,
        campaignCount: route == '/NewPublicationPageCampaign' ? 1 : 0,
        calendarCount: 0,
      }

      const postMetrics = await MetricsCountService.postMetricsCount(
        dataMetrics
      )
    }

    const firstOppenPostIA = await UserAccountsService.getFirstOppenPostIA()

    const firstOppenMyPost =
      await UserAccountsService.getUserAccountFirstOppenMyPost()

    // if (
    //   route == '/FirstPublication' &&
    //   !firstOppenPostIA?.data?.firstOppenPostIA
    // ) {
    //   navigation('/FirstPublication', {
    //     state: { tutorialMovie: true },
    //   })
    //   setLoading(false)
    //   return
    // } else {
    if (
      route == '/NewPublicationPageMyPublication' &&
      !firstOppenMyPost.data.firstOppenMyPost
    ) {
      navigation('/NewPublicationPageMyPublication', {
        state: { tutorialMovie: true },
      })
    } else {
      navigation(`${route}`);
    }
    // }

    // navigation(`${route}`);
    setLoading(false);
  };
  const storage = JSON.parse(window.localStorage.getItem('userData')).userEmail;
  const storageName = JSON.parse(
    window.localStorage.getItem('userData')
  ).userName;
  const userInfo = {
    username: storage, // REQUIRED, must be unique
  }

  const { t } = useTranslation()

  const handleCloseModal = () => {
    setBlockDowngrade(false)
  }

  const handleContinueArtPending = () => {
    setIsArtPendingPopUpOpen(false)
    localStorage.setItem('pendingArtPopupShown', undefined)
    navigation('/NewPublicationPageIA', {
      state: { step: 'stepSubtitles' },
    })
  }

  const handleDiscardArtPending = async () => {
    localStorage.setItem('pendingArtPopupShown', undefined)
    await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
    setIsArtPendingPopUpOpen(false)
    navigation('/NewPublicationPageIA', {
      state: { step: 'stepFirstPass' },
    })
  }

  const handleClosePendingArtPopUp = () => {
    localStorage.setItem('pendingArtPopupShown', undefined)
    setIsArtPendingPopUpOpen(false)
  }

  //const handleRedirectMissionCard = async () => {
  // const { data } =
  //         await BusinessService.getBusinessByLogin()
  // if (data.length <= 0) {
  //   navigation('/NewPublicationPageIA');
  // } else {
  //   if (!firstOppenPostIA?.data?.firstOppenPostIA) {
  //     navigation('/FirstPublication', {
  //       state: { tutorialMovie: true },
  //     })
  //   } else {
  //     navigation('/FirstPublication');
  //   }
  // }
  //navigation('/NewPublicationPageIA');
  //}

  // const handleClickPrimaryBtnMissionModal = () =>{
  //   setRenderBannerReturnPublication(false)
  //   setShowReturnMissionPopUp(false)
  //   handleRediRedirectMissionPopUp()
  // }

  // const handleClickSecondaryBtnMissionModal = () =>{
  //   setRenderBannerReturnPublication(false)
  //   setShowReturnMissionPopUp(false)
  // }


  const handleNavigateWithOptions = async (path, options) => {
    await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
    setArtStatus(null)
    navigation(path, options)
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ width: '100%' }}
    >

      {/* <ReturnFirstMissionModal
        isOpen={!isFirstLoggin && renderBannerReturnPublication }
        missionStatus={userMissionStatus}
        bodyContent={bodyMissionContentModal}
        headerContent={
          <>
            {headerMissionContentModal?.title1}
            <>
              <span>
                {' '}
              </span>

              {headerMissionContentModal?.title2}
            </>
            {' '}
            {headerMissionContentModal?.title3}
          </>
        }
        btnPrimaryText={primaryButtonMissionContentModal}
        btnSecondaryText={secondaryButtonMissionContentModal}
        onClickPrimaryButton={handleClickPrimaryBtnMissionModal}
        onClickSecondaryButton={handleClickSecondaryBtnMissionModal}
      /> */}

      {isArtPendingPopUpOpen && artStatus?.status !== 'ERROR' && (
        <ArtPendingPopUp
          isOpen={isArtPendingPopUpOpen}
          onClose={handleClosePendingArtPopUp}
          onContinue={handleContinueArtPending}
          onDiscard={handleDiscardArtPending}
        />
      )}
      {isArtPendingPopUpOpen && artStatus?.status === 'ERROR' && (
        <ArtStatusErrorPopUp
          isOpen={!artStatus?.isVisualized && artStatus?.status === 'ERROR'}
          onClose={() => handleNavigateWithOptions('/ChatSocket')}
          onRestart={() => handleNavigateWithOptions('/newPublicationPageIa', { state: { step: 'stepSubtitles', showBeacon: true } })}
          onDiscard={async () => {
            await ArtStatusService.updateArtStatusVisualized(artStatus?.uuid)
            setArtStatus(null)
            setIsArtPendingPopUpOpen(false)
          }}
        />
      )}
      <ModalValidDowngrade
        isOpen={blockDowngrade}
        onClose={() => handleCloseModal()}
        handleCloseModal={handleCloseModal}
      />
      <div className={styles.page}>
        <Loading enable={loading} />
        <div className={styles.container_new_posts}>
          <div className={styles.container_title}>
            <h2 className={styles.container_title_title}>
              {t('new_post_page_hello')}, {storageName}
            </h2>
            <h2 style={{ color: '#BEBEBE' }}>
              {t('new_post_page_what_we_go_create_today')}
            </h2>
          </div>

          <div className={styles.container_card}>
            <div
              style={{
                boxShadow: '0px 14px 40px 2px #FF5D025E',
                borderRadius: '30px'
              }}
            >
              <div
                className={styles.card_post_ia}
                style={{
                  background: 'linear-gradient(156.31deg, #FF9E02 0%, #A03400 100%)',
                  boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                }}
                onClick={() => {
                  if (artStatus && !artStatus.isVisualized) {
                    setIsArtPendingPopUpOpen(true)
                    return
                  }
                  handleNavigate('/ChatSocket')
                }}
              >
                <div>
                  <svg
                    width={widthIconPicture}
                    height={widthIconPicture}
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_14040_23468)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M42.1937 13.6078H0.78125V42.1359L11.925 31.8844L18.1195 38.1703L28.5602 28.7203L42.1937 42.1359V40.7953V13.6078Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M28.5594 28.7203L18.1203 38.1703L10.5594 45.0156H42.1945V42.1359L28.5594 28.7203ZM11.925 31.8844L0.78125 42.1359V45.0156H10.5594L18.1187 38.1703L11.925 31.8844Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M45.9173 9.38751H4.50476V13.6078H42.1938V40.7953H45.9173V36.3922V9.38751Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M49.2187 4.98438H7.80621V9.3875H45.9171V36.3922H49.2187V4.98438Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.77347 19.8773C7.11957 19.8773 5.77582 21.218 5.77582 22.8719C5.77582 24.5258 7.11957 25.8695 8.77347 25.8695C9.55624 25.8517 10.3009 25.5282 10.8482 24.9682C11.3955 24.4083 11.7019 23.6564 11.7019 22.8734C11.7019 22.0905 11.3955 21.3386 10.8482 20.7787C10.3009 20.2187 9.55624 19.8952 8.77347 19.8773Z"
                        fill="white"
                      />
                      <path
                        d="M49.2188 4.20312H7.80547C7.59827 4.20312 7.39955 4.28543 7.25304 4.43195C7.10653 4.57846 7.02422 4.77717 7.02422 4.98438V8.60625H4.50469C4.29749 8.60625 4.09877 8.68856 3.95226 8.83507C3.80575 8.98159 3.72344 9.1803 3.72344 9.3875V12.8266H0.78125C0.57405 12.8266 0.375336 12.9089 0.228823 13.0554C0.08231 13.2019 0 13.4006 0 13.6078L0 45.0156C0 45.2228 0.08231 45.4215 0.228823 45.5681C0.375336 45.7146 0.57405 45.7969 0.78125 45.7969H42.1945C42.4017 45.7969 42.6004 45.7146 42.747 45.5681C42.8935 45.4215 42.9758 45.2228 42.9758 45.0156V41.5766H45.9172C46.1244 41.5766 46.3231 41.4943 46.4696 41.3477C46.6161 41.2012 46.6984 41.0025 46.6984 40.7953V37.1734H49.2188C49.4259 37.1734 49.6247 37.0911 49.7712 36.9446C49.9177 36.7981 50 36.5994 50 36.3922V4.98438C50 4.77717 49.9177 4.57846 49.7712 4.43195C49.6247 4.28543 49.4259 4.20312 49.2188 4.20312ZM41.4133 14.3891V40.2711L29.1078 28.1633C28.9659 28.0231 28.7757 27.9427 28.5762 27.9386C28.3768 27.9345 28.1834 28.0071 28.0359 28.1414L18.1508 37.0898L12.4812 31.3352C12.339 31.1907 12.1463 31.1072 11.9437 31.1023C11.741 31.0973 11.5444 31.1713 11.3953 31.3086L1.5625 40.3555V14.3891H41.4133ZM1.5625 42.4789L11.8984 32.9711L16.9914 38.1391L10.257 44.2344H1.5625V42.4789ZM12.5859 44.2344L28.5375 29.7945L41.4125 42.4633V44.2344H12.5859ZM45.1359 40.0141H42.9766V13.6078C42.9766 13.4006 42.8943 13.2019 42.7477 13.0554C42.6012 12.9089 42.4025 12.8266 42.1953 12.8266H5.28594V10.1688H45.1359V40.0141ZM48.4375 35.6109H46.6984V9.3875C46.6984 9.1803 46.6161 8.98159 46.4696 8.83507C46.3231 8.68856 46.1244 8.60625 45.9172 8.60625H8.58672V5.76563H48.4375V35.6109Z"
                        fill="#E98601"
                      />
                      <path
                        d="M8.77349 26.6508C9.77485 26.6491 10.7347 26.2503 11.4424 25.5419C12.1501 24.8335 12.5479 23.8732 12.5485 22.8719C12.5475 21.8709 12.1494 20.9113 11.4417 20.2034C10.734 19.4956 9.77443 19.0973 8.77349 19.0961C7.77212 19.0969 6.81198 19.4949 6.10369 20.2028C5.3954 20.9106 4.99681 21.8705 4.99536 22.8719C4.9966 23.8736 5.39503 24.8339 6.10327 25.5423C6.81152 26.2507 7.77177 26.6493 8.77349 26.6508ZM8.77349 20.6586C9.3609 20.6586 9.92425 20.8919 10.3396 21.3073C10.755 21.7227 10.9883 22.286 10.9883 22.8734C10.9883 23.4609 10.755 24.0242 10.3396 24.4396C9.92425 24.8549 9.3609 25.0883 8.77349 25.0883C8.18598 25.0875 7.62279 24.8537 7.20744 24.4382C6.79209 24.0227 6.55848 23.4594 6.55786 22.8719C6.5589 22.2848 6.79273 21.7221 7.20809 21.3072C7.62344 20.8923 8.1864 20.659 8.77349 20.6586Z"
                        fill="#E98601"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14040_23468">
                        <rect width="50" height="50" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div className={styles.card_post_body}>
                  <h2>{t('new_campaign_page_card_title')}</h2>
                  <p>{t('new_campaign_page_card_subtitle')}</p>
                </div>
              </div>
            </div>
            <div
              style={{
                boxShadow: '0px 14px 40px 2px #6A009880',
                borderRadius: '30px'
              }}
            >
              <div
                className={styles.card_post_ia}
                style={{
                  background:
                    'linear-gradient(156.31deg, #6A0098 45%, #9F00E4 100%)',
                  boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                }}
                onClick={() => {
                  if (artStatus && !artStatus.isVisualized) {
                    setIsArtPendingPopUpOpen(true)
                    return
                  }
                  handleNavigate('/NewPublicationPageIA')
                }}
              >
                <div>
                  <svg
                    width={widthIconPicture}
                    height={widthIconPicture}
                    viewBox="0 0 102 103"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_14678_58744)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.9286 0.889648C8.03017 0.889648 5.25041 2.04105 3.20091 4.09055C1.1514 6.14006 0 8.91982 0 11.8182V70.1039C0 73.0024 1.1514 75.7824 3.20091 77.8319C5.25041 79.8814 8.0301 81.0325 10.9286 81.0325H40.7293C39.6728 77.4778 39.8888 73.5542 41.3775 70.1512L12.9303 70.1511C11.9244 70.1511 11.1089 69.3356 11.1089 68.3296V47.084L12.5871 46.8185C26.7883 44.268 41.2163 49.9257 49.8985 61.4495L50.4183 62.1396C51.0769 61.936 51.767 61.7686 52.4885 61.641C56.4036 60.9484 59.6891 57.8707 60.6001 53.6389L60.7518 52.934C62.8735 43.0785 72.3846 39.288 80.1429 41.6344V11.8182C80.1429 8.91974 78.9917 6.14006 76.9422 4.09055C74.8928 2.04105 72.1128 0.889648 69.2143 0.889648H10.9286ZM34.6071 28.2111C34.6071 22.1754 39.5 17.2825 45.5357 17.2825C51.5714 17.2825 56.4643 22.1754 56.4643 28.2111C56.4643 34.2468 51.5714 39.1396 45.5357 39.1396C39.5 39.1396 34.6071 34.2468 34.6071 28.2111ZM69.655 54.8506C71.0209 48.5054 80.003 48.4601 81.4251 54.7993L81.6087 55.6207C83.3471 63.369 89.4744 69.2493 97.0938 70.5973C103.636 71.7544 103.636 81.2037 97.0938 82.3607C89.4744 83.7085 83.3471 89.5889 81.6087 97.3372L81.4251 98.1583C80.003 104.498 71.0209 104.452 69.655 98.1073L69.5032 97.4028C67.8288 89.6238 61.7079 83.6991 54.075 82.349C47.5464 81.1943 47.5464 71.7638 54.075 70.6089C61.7079 69.2586 67.8288 63.3338 69.5032 55.5555L69.655 54.8506Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14678_58744">
                        <rect
                          width="102"
                          height="102"
                          fill="white"
                          transform="translate(0 0.889648)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div className={styles.card_post_body}>
                  <h2>{t('new_post_page_second_card_title')}</h2>
                  <p>{t('new_post_page_second_card_subtitle')}</p>
                </div>
              </div>
            </div>
            <div
              className={styles.card_post_unic}
              id="unicPost"
              onClick={() => {
                handleNavigate('/NewPublicationPageMyPublication');
              }}
            >
              <div>
                <svg
                  width={widthIcon}
                  height={widthIcon}
                  viewBox="0 0 92 93"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_14678_58715)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 0.890625C20.3858 0.890625 17.8785 1.92914 16.0299 3.77772C14.1814 5.62628 13.1429 8.13346 13.1429 10.7478V44.8448C15.3929 43.041 18.2491 41.962 21.3573 41.962C28.6159 41.962 34.5002 47.8463 34.5002 55.1049V58.3906H37.7859C45.0445 58.3906 50.9288 64.2749 50.9288 71.5332C50.9288 78.792 45.0445 84.6761 37.7859 84.6761H34.5002V87.9618C34.5002 89.7052 34.1609 91.3684 33.5448 92.8903H82.1429C84.757 92.8903 87.2646 91.8521 89.1132 90.0035C90.9617 88.155 92 85.648 92 83.0332V27.1763C92 26.3049 91.6537 25.4691 91.0379 24.853L68.0379 1.85299C67.4215 1.2368 66.5857 0.890625 65.7143 0.890625H23ZM26.2857 55.1049C26.2857 52.383 24.0791 50.1763 21.3571 50.1763C18.6352 50.1763 16.4286 52.383 16.4286 55.1049V66.6049H4.92857C2.20659 66.6049 0 68.8113 0 71.5332C0 74.2557 2.20659 76.4618 4.92857 76.4618H16.4286V87.9618C16.4286 90.6843 18.6352 92.8903 21.3571 92.8903C24.0791 92.8903 26.2857 90.6843 26.2857 87.9618V76.4618H37.7857C40.5077 76.4618 42.7143 74.2557 42.7143 71.5332C42.7143 68.8113 40.5077 66.6049 37.7857 66.6049H26.2857V55.1049Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 0.890625C20.3858 0.890625 17.8785 1.92914 16.0299 3.77772C14.1814 5.62628 13.1429 8.13346 13.1429 10.7478V44.8448C15.3929 43.041 18.2491 41.962 21.3573 41.962C28.6159 41.962 34.5002 47.8463 34.5002 55.1049V58.3906H37.7859C45.0445 58.3906 50.9288 64.2749 50.9288 71.5332C50.9288 78.792 45.0445 84.6761 37.7859 84.6761H34.5002V87.9618C34.5002 89.7052 34.1609 91.3684 33.5448 92.8903H82.1429C84.757 92.8903 87.2646 91.8521 89.1132 90.0035C90.9617 88.155 92 85.648 92 83.0332V27.1763C92 26.3049 91.6537 25.4691 91.0379 24.853L68.0379 1.85299C67.4215 1.2368 66.5857 0.890625 65.7143 0.890625H23ZM26.2857 55.1049C26.2857 52.383 24.0791 50.1763 21.3571 50.1763C18.6352 50.1763 16.4286 52.383 16.4286 55.1049V66.6049H4.92857C2.20659 66.6049 0 68.8113 0 71.5332C0 74.2557 2.20659 76.4618 4.92857 76.4618H16.4286V87.9618C16.4286 90.6843 18.6352 92.8903 21.3571 92.8903C24.0791 92.8903 26.2857 90.6843 26.2857 87.9618V76.4618H37.7857C40.5077 76.4618 42.7143 74.2557 42.7143 71.5332C42.7143 68.8113 40.5077 66.6049 37.7857 66.6049H26.2857V55.1049Z"
                      fill="url(#paint0_linear_14678_58715)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 0.890625C20.3858 0.890625 17.8785 1.92914 16.0299 3.77772C14.1814 5.62628 13.1429 8.13346 13.1429 10.7478V44.8448C15.3929 43.041 18.2491 41.962 21.3573 41.962C28.6159 41.962 34.5002 47.8463 34.5002 55.1049V58.3906H37.7859C45.0445 58.3906 50.9288 64.2749 50.9288 71.5332C50.9288 78.792 45.0445 84.6761 37.7859 84.6761H34.5002V87.9618C34.5002 89.7052 34.1609 91.3684 33.5448 92.8903H82.1429C84.757 92.8903 87.2646 91.8521 89.1132 90.0035C90.9617 88.155 92 85.648 92 83.0332V27.1763C92 26.3049 91.6537 25.4691 91.0379 24.853L68.0379 1.85299C67.4215 1.2368 66.5857 0.890625 65.7143 0.890625H23ZM26.2857 55.1049C26.2857 52.383 24.0791 50.1763 21.3571 50.1763C18.6352 50.1763 16.4286 52.383 16.4286 55.1049V66.6049H4.92857C2.20659 66.6049 0 68.8113 0 71.5332C0 74.2557 2.20659 76.4618 4.92857 76.4618H16.4286V87.9618C16.4286 90.6843 18.6352 92.8903 21.3571 92.8903C24.0791 92.8903 26.2857 90.6843 26.2857 87.9618V76.4618H37.7857C40.5077 76.4618 42.7143 74.2557 42.7143 71.5332C42.7143 68.8113 40.5077 66.6049 37.7857 66.6049H26.2857V55.1049Z"
                      fill="url(#paint1_linear_14678_58715)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23 0.890625C20.3858 0.890625 17.8785 1.92914 16.0299 3.77772C14.1814 5.62628 13.1429 8.13346 13.1429 10.7478V44.8448C15.3929 43.041 18.2491 41.962 21.3573 41.962C28.6159 41.962 34.5002 47.8463 34.5002 55.1049V58.3906H37.7859C45.0445 58.3906 50.9288 64.2749 50.9288 71.5332C50.9288 78.792 45.0445 84.6761 37.7859 84.6761H34.5002V87.9618C34.5002 89.7052 34.1609 91.3684 33.5448 92.8903H82.1429C84.757 92.8903 87.2646 91.8521 89.1132 90.0035C90.9617 88.155 92 85.648 92 83.0332V27.1763C92 26.3049 91.6537 25.4691 91.0379 24.853L68.0379 1.85299C67.4215 1.2368 66.5857 0.890625 65.7143 0.890625H23ZM26.2857 55.1049C26.2857 52.383 24.0791 50.1763 21.3571 50.1763C18.6352 50.1763 16.4286 52.383 16.4286 55.1049V66.6049H4.92857C2.20659 66.6049 0 68.8113 0 71.5332C0 74.2557 2.20659 76.4618 4.92857 76.4618H16.4286V87.9618C16.4286 90.6843 18.6352 92.8903 21.3571 92.8903C24.0791 92.8903 26.2857 90.6843 26.2857 87.9618V76.4618H37.7857C40.5077 76.4618 42.7143 74.2557 42.7143 71.5332C42.7143 68.8113 40.5077 66.6049 37.7857 66.6049H26.2857V55.1049Z"
                      fill="url(#paint2_linear_14678_58715)"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_14678_58715"
                      x1="92"
                      y1="5.05127"
                      x2="-15.3788"
                      y2="56.8485"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#080640" />
                      <stop offset="0.423278" stopColor="#A22AFB" />
                      <stop offset="1" stopColor="#C369FD" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_14678_58715"
                      x1="4.57801e-06"
                      y1="103"
                      x2="114.384"
                      y2="45.6213"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8100B9" />
                      <stop offset="0.423278" stopColor="#660095" />
                      <stop offset="1" stopColor="#28003F" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_14678_58715"
                      x1="0"
                      y1="0.890625"
                      x2="48.6996"
                      y2="111.888"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6A0098" />
                      <stop offset="1" stopColor="#9F00E4" />
                    </linearGradient>
                    <clipPath id="clip0_14678_58715">
                      <rect
                        width="92"
                        height="92"
                        fill="white"
                        transform="translate(0 0.890625)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div className={styles.card_post_body_unic}>
                <h2 className={styles.teste}>
                  {t('new_post_page_first_card_title')}
                </h2>
                <p>{t('new_post_page_first_card_subtitle')}</p>
              </div>
            </div>
          </div>

          <div className={styles.container_modal_box_main}>

            <RoundedProgressBarCard
              onClick={() => navigation('/ChatSocket', {
                state: { parametersComplete: true },
              })}
              label={t('parameter_title')}
              title={parameterPercent === '1'
                ? t('parameter_text_complete')
                : t('parameter_text')}
              parameterPercent={parameterPercent}
              percentString={percentString}
              bodyText={t('parameter_text_2')}
              btnText={
                parameterPercent === '1'
                  ? t('parameter_button_complete')
                  : t('parameter_button')}
            />

            {/* {showPercentageCard &&  (
              <RoundedProgressBarCard
                bodyText={missionPercentageCardContentToRender.bodyText}
                btnText={missionPercentageCardContentToRender.btnText}
                label={missionPercentageCardContentToRender.label}
                onClick={handleClickPercentageCardNavigateButton}
                parameterPercent={stepsMissionCompleted / maxSteps}
                percentString={Math.round(stepsMissionCompleted / maxSteps * 100)}
                title={missionPercentageCardContentToRender.title}
              />
            )} */}
          </div>
          {showSevenDaysModal && (
            <SatisfactionPopUp
              isOpen={showSevenDaysModal}
              title={t('pop_up_seven_days.title')}
              primaryButton={t('pop_up_seven_days.send_button')}
              onClickPrimaryBtn={() => handleSendStars()}
              onChangeStars={(e) => userRating = e}
              content={t('pop_up_seven_days.description')}
            />
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default NewPostPage
